import { useCallback, useContext, useEffect } from 'react';
import { useAppSelector } from '@redux/store.ts';

import { IntroContext } from '../context';

const useIntroClickHandler = (): void => {
  const { activeStep, toNextStep, startOnboarding, finishOnboarding } =
    useContext(IntroContext);
  const userId = useAppSelector((state) => state.user.user?.id);

  const onClick = useCallback(
    (event: MouseEvent): void => {
      const targetElem = document.getElementById(`intro-step-${activeStep}`);
      const nextButton = document.getElementById('intro-next-button');
      const additionalButton = document.getElementById(
        'intro-additional-button',
      );
      const node = event.target as Node;
      const isContains = targetElem?.contains(node);
      const isNextButton = nextButton?.contains(node);
      const isAdditionalButton = additionalButton?.contains(node);

      if (isAdditionalButton) {
        localStorage.setItem(`refuseOnboarding_user_${userId}`, 'true');
        finishOnboarding();

        return;
      }

      if (isContains || isNextButton) {
        if (activeStep === 26) {
          return startOnboarding('finishOnboarding');
        }

        return toNextStep();
      } else {
        event.stopPropagation();
        event.preventDefault();
      }
    },
    [activeStep, toNextStep],
  );

  useEffect(() => {
    document.body.addEventListener('click', onClick, { capture: true });

    return (): void => {
      document.body.removeEventListener('click', onClick, { capture: true });
    };
  }, [onClick]);
};

export { useIntroClickHandler };
